import _find from 'lodash/find';
import { KoDate, KoForm, KoFormBuilder,  KoRichTextEditor, KoSelect, KoText, KoToast } from 'packages';
import KoIcon from '@kwapio/icons';
import { useCallback, useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { Tooltip } from 'antd';
import { DevelopmentAPI } from 'pages/workspace/process/development/development.service';
import {TIMESPEND } from 'shared/commonConstants';
import styles from './timesheet.module.scss';
import { useSelector } from 'react-redux';
import { KO_DEVELOPMENT } from 'shared/types/development';


function TimeSheetCurd({ form,currentPeriod, handleFinish, initialValues, setModal, workspace  }) {
  const [tickets, setTickets] = useState();
  const projectId = KoForm.useWatch('project', form);
  const holidays = useSelector(state => state?.holidays);

  const [iserror, setIsError] = useState(false);
 
  useEffect(()=>{
    form.setFieldsValue({
      project: projectId || initialValues?.workspace,
      task: initialValues?.ticketId?.length > 0 ? initialValues?.ticketId: undefined,
      isBillable: workspace?.typeofBilling === 'nonBillable' ? false : true
    });
    getMyTickets(projectId || initialValues?.workspace);
  }, [projectId, initialValues?.workspace]);

 
  const getMyTickets=(workspaceId)=>{
    setTickets();
    DevelopmentAPI.getIssues({}, workspaceId).then(
      (data) => {
        setTickets(data?.tickets);
      },
      (err) => {
      }
    );
  };

  const MyTickets = ({ value, onChange }) => {
    


    const options = tickets?.map((ticket) => {
      const issueType = _find(KO_DEVELOPMENT, (o) => o.value === ticket.issueType);

      return {
        label: (
          <div className={styles.TicketIdWrapper} aria-label={ticket?.ticketId}>
            <KoIcon name={issueType.icon} />
            <KoText className={styles.text} text={`${ticket?.ticketId} -`} />
            <KoText ellipsis={true} className={styles.text} text={ticket?.summary} />
          </div>
        ),
        value: ticket?.ticketId,
        title: ticket?.summary
      };
    });
    
    return (
      <KoSelect
        value={value}
        onChange={(v) => onChange(v) }
        showSearch
        disabled={!initialValues?.workspace }
        // mode="multiple"
        
        maxTagPlaceholder={(omittedValues) => (
         
          <Tooltip
            overlayStyle={{
              pointerEvents: 'none'
            }}
            title={omittedValues.map(({ title, value }) => value + '-' + title).join(', ')}
          >
            <span>{`${omittedValues?.length} tasks added`}</span>
          </Tooltip>
        )}
        placeholder="Select task Id"
        options={options}
      />
    );
  };


  const handleSubmit = useCallback(values => {
    const isTextEmpty = _isEmpty(_get(values?.description, '[0].children[0].text', ''));

    if (isTextEmpty && (!values?.task || values?.task?.length === 0)) {
      setIsError(true);
      KoToast.error('Description or Task is required');
      return;
    }else{
      setIsError(false);
    }

    handleFinish(values);
  });


  const Date = ({ value, onChange }) =>
    <KoDate value={value} dateFormat = {'DD-MMM-YYYY'}
      intervalStart={currentPeriod?.intervalStart}
      intervalEnd={currentPeriod?.intervalEnd}
      holidays={holidays['data']}
      onChange={v => onChange(v)} />;

  // const Time = ({ value, onChange }) => {
  //   const handleChange = (v) => {
  //     const formattedValue = v instanceof Date ? v.toTimeString().slice(0, 5) : v;
  //     onChange(formattedValue);
  //   };

  //   const formattedValue = value ? (value instanceof Date ? value.toTimeString().slice(0, 5) : value) : '';

  //   return (
  //     <KoTimePicker
  //       changeOnScroll
  //       needConfirm={false}
  //       allowClear={false}
  //       value={formattedValue}
  //       format='HH:mm'
  //       onChange={handleChange}
  //     />
  //   );
  // };

  
  const enabledButtons = {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    numberedList: true,
    unorderedList: true,
    codeBlock: true,
    link: true,
    insertTable: true,
    uploadImageButton: true,
    uploadVideoButton: true
  };
  
  const Description = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons}
      value={value}
      initialValues={value}
      form={form} name='description'
      placeholder='Add a description...'
      onSetEditorValues={v => onChange(v)}
    />;

  const TimeSpentSelect = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value || undefined}
        placeholder="Ex: 1w 3d 6h 20m"
        showSearch
        onChange={(v) => onChange(v)}
        options={TIMESPEND}     />
    );
  };

  const Billable = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value || undefined}
        placeholder="Select Billing Type"
        showSearch
        onChange={(v) => onChange(v)}
        options={[{ value: true, label: 'Billable'}, { value: false, label: 'Non - Billable'}]} />
    );
  };

  const meta = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'date', placeholder: 'Choose Date', label: 'Date', colSpan: 3, widget: Date, rules: [
          {
            required: true,
            message: `Choose Date.`
          }
        ]
      },
      {
        key: 'isBillable', label: 'Billable / Non-Billable', colSpan: 3,widget: Billable
      },
      {
        key: 'timeSpent', label: 'Time spent', colSpan: 3, placeholder: 'Ex: 1w 3d 6h 20m',  widget: TimeSpentSelect,
        rules: [
          {
            required: true,
            message: `Please enter time spent.`
          }
        ]
      },
      {
        key: 'timeRemaining', label: 'Time remaining', colSpan: 3, placeholder: 'Ex: 1w 3d 6h 20m',  widget: TimeSpentSelect
      },
     
      {
        key: 'task', label: 'Tasks', colSpan: 6, widget: MyTickets
      },
      { key: 'description', placeholder: 'Enter Instruction / Description/ Notes', label: 'Instruction / Description/ Notes', colSpan: 6,
        widget: Description
      },
      {
        key: '', colSpan: 6,
        render() {
          return (
            <div className={styles.timeFormatInfo}>
              {iserror && <span className={'rejected'}>Description or Task is required</span>}
            </div>
          );
        }
      }
    ]
  };


  return (
    <div className={styles.timesheetCrudwrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
};

export default TimeSheetCurd;